module.exports = __webpack_public_path__ + "img/img-5.f9bffd80.gif";